import { TrackingService } from '../tracking-service/tracking-service'
import { ElementsVisibleObserverPort } from '../../ports'

export class PreferenceCenterTracking {
  static readonly PREFERENCE_CENTER_ID = '#onetrust-pc-sdk'
  private isCurrentlyVisible = false

  constructor(
    private readonly elementsVisibleObserver: ElementsVisibleObserverPort,
    private readonly trackingService: TrackingService
  ) {}

  public registerViewTrackingListener(): void {
    this.elementsVisibleObserver.observe(
      PreferenceCenterTracking.PREFERENCE_CENTER_ID,
      (isVisible) => {
        if (!this.isCurrentlyVisible && isVisible) {
          void this.trackingService.trackOTPreferenceCenterView()
        }
        this.isCurrentlyVisible = isVisible
      }
    )
  }
}
